import { BpkButtonV2 } from '@skyscanner/backpack-web/bpk-component-button';
import BpkCard from '@skyscanner/backpack-web/bpk-component-card';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './StickyButton.module.scss';

import {
  useLowestPrice,
  useStay,
} from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import CenteredSpinner from '@shared/ui/components/CenteredSpinner';
import { FormattedMessage } from '@shared/ui/components/i18n';
import { withI18n } from '@shared/ui/contexts/i18n';
import { scrollToHotelPrices } from '@shared/utils-frontend/navigation-service';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  isSubPage?: boolean;
  onClick?: () => void;
};

const StickyButton = ({ i18n, isSubPage, onClick }: Props) => {
  const stay = useStay();
  const price = useLowestPrice().lowestPriceForTraveller;

  const getPriceText = () => {
    if (price && stay) {
      return (
        <BpkText
          textStyle={TEXT_STYLES.caption}
          className={cls('BottomStickyButtonRr__priceTextInfo')}
          color={TEXT_COLORS.textSecondary}
        >
          {price && (
            <FormattedMessage
              label="CityCard_label_fromPrice"
              data={{
                price: (
                  <BpkText
                    textStyle={TEXT_STYLES.label1}
                    className={cls('BottomStickyButtonRr__lowestPrice')}
                    color={TEXT_COLORS.textPrimary}
                  >
                    {i18n.formatCurrency(price)}
                  </BpkText>
                ),
              }}
            />
          )}
        </BpkText>
      );
    }

    return <CenteredSpinner />;
  };

  return (
    <BpkCard
      className={cls('BottomStickyButtonRr')}
      atomic={false}
      onClick={() => {
        if (isSubPage && typeof onClick === 'function') {
          onClick();
          // when modal close only in the next tick can go back to lowest price section
          setTimeout(() => {
            scrollToHotelPrices();
          }, 100);
        }
      }}
    >
      {getPriceText()}
      <BpkButtonV2
        large
        data-test-id="see-best-deal-button"
        className={cls('BottomStickyButtonRr__dealsButtonRr')}
      >
        <BpkText
          textStyle={TEXT_STYLES.bodyLongform}
          className={cls('BottomStickyButtonRr__btnText')}
        >
          {i18n.translate('RoomOptions_button_viewDeals')}
        </BpkText>
      </BpkButtonV2>
    </BpkCard>
  );
};

export default withI18n(StickyButton);
